import { EMAIL, FIRSTNAME, LASTNAME, ROLE, CHANNEL_PARTNER } from './fields'

export const EDIT_USER = {
    TITLE: 'Edit User',
    FIELDS: {
        EMAIL: EMAIL,
        FIRSTNAME: FIRSTNAME,
        LASTNAME: LASTNAME,
        ROLE: ROLE,
    },
    SUBMIT_BUTTON: 'Save',
} as const;

export const CREATE_USER = {
    TITLE: 'Create User',
    FIELDS: {
        EMAIL: EMAIL,
        FIRSTNAME: FIRSTNAME,
        LASTNAME: LASTNAME,
        ROLE: ROLE,
        CHANNEL_PARTNER: CHANNEL_PARTNER,
    },
    SUBMIT_BUTTON: 'Create',
} as const;